module.exports = __webpack_public_path__ + "media/components/assets/icons/share_lecture-c5000783becc1a25ff4a23654c63cc7f.svg";